export default "__VITE_ASSET__Cz$SV7ja__"